import {AfterViewInit, Component, OnInit} from '@angular/core';
import {StepComponent} from "../../step/step.component";
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {WarmwassercheckAnfrage} from "../anfrage/warmwassercheck.anfrage";
import {WarmwassercheckRequestService} from "../services/request.service";
import {WarmwassercheckConstants} from "../warmwassercheck.constants";

/**
 * Special component for the step to stop the advisor because we can not offer anything to the user
 */
@Component({
    selector: 'app-wwc-ausstieg',
    templateUrl: './eingabe.ausstieg.component.html',
    standalone: false
})
export class EingabeAusstiegComponent extends StepComponent implements OnInit, AfterViewInit {

  /**
   * The last step were we should navigate with the back button to.
   */
  lastStep: string = "../../eingabe";

  /**
   * define the case why we stop here.
   */
  case: string = null;

  /**
   * the anfrage object with the input of the user
   */
  anfrage: WarmwassercheckAnfrage;

  /**
   * Overwrite the label prefix.
   */
  textkeyPrefix = 'warmwassercheck';

  /**
   * Url on button where we want to forward user
   */
  url: string;

  /**
   *
   * @param stepService
   * @param router
   * @param elementService
   * @param portalService
   * @param requestService
   */
  constructor(protected stepService: StepService, protected router: Router, protected elementService: ElementService, protected portalService: PortalService,
              protected requestService: WarmwassercheckRequestService) {
    super(stepService, router, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    // get the input data
    this.anfrage = this.requestService.getAnfrage();

    // check if there is a last step given were we should navigate in case of the backstep to
    if(history?.state?.lastStep) {
      this.lastStep = history.state.lastStep;
    }

    // set url to divert to heizcheck
    this.url = 'https://www.co2online.de/service/energiesparchecks/heizcheck/';

    // case hausverwaltung
    if (this.anfrage.userInput?.nutzungstyp === WarmwassercheckConstants.NUTZUNGSTYP_HAUSVERWALTER) {
      this.case = WarmwassercheckConstants.NUTZUNGSTYP_HAUSVERWALTER;
    }

    // case hauseigentuemer in mfh
    if (this.anfrage.userInput?.nutzungstyp === WarmwassercheckConstants.NUTZUNGSTYP_HAUSEIGENTUEMER &&
      this.anfrage.userInput.gebaeudetyp === WarmwassercheckConstants.GEBAEUDETYP_MFH) {
      this.case = 'hauseigentuemer_mfh';
    }
  }

  /**
   * @inheritDoc
   */
  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    // scroll to the top
    const element = document.querySelector("body");
    this.elementService.scrollToElement(element);
  }
}
